import { render, staticRenderFns } from "./ProductBoxItem.vue?vue&type=template&id=663d9e6e&"
import script from "./ProductBoxItem.vue?vue&type=script&lang=ts&"
export * from "./ProductBoxItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductBoxItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663d9e6e')) {
      api.createRecord('663d9e6e', component.options)
    } else {
      api.reload('663d9e6e', component.options)
    }
    module.hot.accept("./ProductBoxItem.vue?vue&type=template&id=663d9e6e&", function () {
      api.rerender('663d9e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductBoxItem.vue"
export default component.exports